import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title, 
  description, 
  canonical, 
  noindex = false 
}) => {
  const baseUrl = 'https://powershellguibuilder.com';
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  
  return (
    <Helmet>
      <title>{title || 'PowerShell GUI Builder - Create Windows Applications with Drag & Drop'}</title>
      <meta name="description" content={description || 'Build beautiful PowerShell GUI applications with drag-and-drop interface. Create, design, and export professional Windows applications easily.'} />
      <link rel="canonical" href={fullCanonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow" />}
      <meta name="googlebot" content="index, follow" />
      
      {/* Open Graph */}
      <meta property="og:title" content={title || 'PowerShell GUI Builder'} />
      <meta property="og:description" content={description || 'Build beautiful PowerShell GUI applications with drag-and-drop interface.'} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || 'PowerShell GUI Builder'} />
      <meta name="twitter:description" content={description || 'Build beautiful PowerShell GUI applications with drag-and-drop interface.'} />
    </Helmet>
  );
};

export default SEO; 